var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85942 25.6652V17.0202H7.17925V13.0476H9.85942V11.3359C9.85942 6.91052 11.8614 4.85977 16.2056 4.85977C16.64 4.85977 17.2402 4.90527 17.7959 4.97136C18.2122 5.01419 18.6251 5.08476 19.032 5.18261V8.78469C18.7968 8.76275 18.5608 8.74974 18.3246 8.74569C18.0599 8.73882 17.7952 8.73557 17.5305 8.73594C16.7646 8.73594 16.1666 8.83994 15.7159 9.07069C15.4129 9.2227 15.1583 9.45601 14.9803 9.74452C14.7008 10.1995 14.5752 10.8224 14.5752 11.6425V13.0476H18.8207L18.4026 15.3259L18.0917 17.0202H14.5752V25.9523C21.0123 25.1744 26 19.6939 26 13.0476C26 5.86836 20.1793 0.0476074 13 0.0476074C5.82075 0.0476074 0 5.86836 0 13.0476C0 19.1446 4.19683 24.2601 9.85942 25.6652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1aa09bb15acca49fa817edb58d68c11d.svg";
export { ForwardRef as ReactComponent };